
import { useState, useEffect } from "react"
import "../css/Lobbies.css";

import { useNavigate } from "react-router";

async function CallAPI(url, body){

    if(!body) {
        body = {
            credentials: "include"
        }
    }
    else{
        body.credentials = "include"
    }
    
    const response = await fetch(
        `https://anagrams.ca/api/${url}`,
           body
    );

    return response
}

export default function ConnectFourLobby() {

    const navigate = useNavigate()
    const [games, setGames] = useState([]);
    const [profile, setProfile] = useState({});

    useEffect(() => {
        async function loadGameList() {
            const response = await CallAPI('connect/lobbies');
            const data = await response.json();
            setGames(data)
        }
        async function getProfile(){
            const response = await CallAPI("account/me");
            const data = await response.json();
            setProfile(data.profile);
        }
        getProfile()
        loadGameList()
        const interval = setInterval(loadGameList, 5000)
        const interval2 = setInterval(getProfile, 15000)
        return () =>{
            
            clearInterval(interval);
            clearInterval(interval2);

        }

    }, [])

    async function joinGameClick(gameId, user) {

        console.log('Joining Game')
        const username = profile.displayName

        if(!username){
            return
        }

        const response = await CallAPI(`connect/${gameId}/join?username=${username}`, {
            method: "POST"
        });

        const data = await response.json();

        if(data['error']){
            console.log('Error')
            console.log(data)
            return alert(data['error']);
        }
        
        console.log(`Recieved data for joining..`)
        console.log(data)

        navigate(`/connectfour`, {
            state: {
                gameId: data['game_id'],
                username: username
            }
        });
        
    }

    async function createGame(){
        const username = profile.displayName

        if(!username){
            return;
        } 
        const response = await CallAPI(`connect/create?username=${username}`, {

            method: "POST"
        });

        const data = await response.json();

        if(data['error']){
            return alert(data['error']);
        }
        console.log('Recieved Data from joining...');
        console.log(data)
        navigate(`/connectfour`, {
            state: {
                gameId: data['gameId'],
                username: username
            }
        });

    }

    return (
        <>
            <div className="Title">
                <h1>Connect Four Lobbies</h1>
            </div>
            <button className="createGameButton connfourCGB" onClick={() => createGame()}>Create Game!</button>
            <div className="GameList">
                <PrintGames games={games} joinClick={joinGameClick} />
            </div>
        </>
    )
}


function PrintGames({ games, joinClick }) {
    return (
        <>
            {games.map((game) => {

                if (game.players.list.length >= 2) {
                    return null;
                }

                return (
                    <div className="game" key={game.game_id}>
                        <div className="game-header">
                            <div className="game-info">

                                <p>
                                    <b>Game ID:</b> {game.game_id}
                                </p>

                                <p>
                                    <b>Players:</b>{" "}
                                    {game.players.list.join(", ")}
                                </p>

                            </div>

                            <button
                                className="join-btn"
                                onClick={() => joinClick(game.game_id)}
                            >
                                Join Game
                            </button>

                        </div>
                    </div>
                );
            })}
        </>
    );
}


function CreateGame({callback}){
    return (
    <>

    <button className="createGameButton"
        onClick={() => callback()}>
    </button>

    </>
        )
}
